import { LinkNode } from "@lexical/link";

import { EditorConfig } from "lexical";

export class CustomLinkNode extends LinkNode {
  __target: string | null;
  __rel: string | null;

  constructor(
    url: string,
    target: string | null = null,
    rel: string | null = null
  ) {
    super(url);
    this.__target = target;
    this.__rel = rel;
  }

  static getType(): string {
    return "custom-link";
  }

  static clone(node: CustomLinkNode): CustomLinkNode {
    return new CustomLinkNode(node.__url, node.__target, node.__rel);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config);
    if (this.__target) {
      dom.setAttribute("target", this.__target);
    }
    if (this.__rel) {
      dom.setAttribute("rel", this.__rel);
    }
    return dom;
  }

  exportJSON(): any {
    const json = super.exportJSON();
    return {
      ...json,
      target: this.__target,
      rel: this.__rel,
    };
  }

  setTarget(target: string | null): void {
    this.__target = target;
  }

  setRel(rel: string | null): void {
    this.__rel = rel;
  }

  getTarget(): string | null {
    return this.__target;
  }

  getRel(): string | null {
    return this.__rel;
  }
}
